import request from '../../axios';

const getMyStoreStoreLabNotifModal = async () => {
  const {data}: {data: IStoreAndLabModal} = await request.get(
    `api/v2/store/mystorepage-store-lab-notif-modal`,
  );
  return data;
};

export default getMyStoreStoreLabNotifModal;
